import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import {
	buttonNormalize,
	fontFamily,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	PaletteColor,
} from '@calm-web/design-system';
import { ChevronDown } from '@calm-web/icons';

export const Wrapper = styled.div`
	position: relative;
`;

export const Trigger = styled.button<{ $textColor: PaletteColor }>`
	${buttonNormalize}
	align-items: center;
	color: ${p => palette(p.$textColor)};
	cursor: pointer;
	display: inline-flex;
	gap: 8px;
	transition: ${theme('animation.transition')};
	${fontFamily}
	${fontSize(FontSizes.base)}
	${fontWeight(FontWeights.Demi)}
`;

export const Chevron = styled(ChevronDown)`
	height: 6px;
	width: 10px;

	path {
		fill: currentColor;
	}
`;

// The padding bridges the trigger and the visible panel, so the pointer never
// leaves the wrapper while moving down to an item.
export const Panel = styled.div`
	left: 50%;
	padding-top: 8px;
	position: absolute;
	top: 100%;
	transform: translateX(-50%);
	z-index: 1;
`;

export const List = styled.ul`
	background: ${palette('white')};
	border-radius: 10px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
	list-style: none;
	margin: 0;
	padding: 0;
`;

export const ItemLink = styled.a`
	color: ${palette('gray7')};
	display: block;
	line-height: 1.5;
	padding: 16px 20px 12px;
	text-align: center;
	text-decoration: none;
	white-space: nowrap;
	${fontSize(FontSizes.base)}
	${fontWeight(FontWeights.Demi)}

	li:first-child > & {
		border-radius: 10px 10px 0 0;
	}

	li:last-child > & {
		border-radius: 0 0 10px 10px;
	}

	&:hover,
	&:focus-visible {
		background: linear-gradient(360deg, #e7f6ff 0%, #ffffff 56.36%);
	}
`;
